__turbopack_context__.v({
  "bounce": "_5oUupW_bounce",
  "fadeIn": "_5oUupW_fadeIn",
  "flip": "_5oUupW_flip",
  "pop": "_5oUupW_pop",
  "shake": "_5oUupW_shake",
});
